import { IPreferences } from "@/androidPlugins/IPreferences"

const DEFAULT_TILL_ROUTE_KEY = "defaultTillRoute"

const defaultTillRoute = ref<
  "quickTill" | "fullTill" | null | undefined
>()

const hydrateDefaultTillRoute = async () => {
  const { value } = await IPreferences.get({
    key: DEFAULT_TILL_ROUTE_KEY,
  })

  defaultTillRoute.value =
    value === "quickTill" || value === "fullTill"
      ? value
      : null
}

const setDefaultTillRoute = async (newValue: string) => {
  if (newValue !== "quickTill" && newValue !== "fullTill") {
    return
  }

  defaultTillRoute.value = newValue

  await IPreferences.set({
    key: DEFAULT_TILL_ROUTE_KEY,
    value: newValue,
  })
}

export const useDefaultTillRoute = () => {
  if (defaultTillRoute.value === undefined) {
    hydrateDefaultTillRoute()
  }

  return {
    defaultTillRoute: readonly(defaultTillRoute),
    setDefaultTillRoute,
  }
}
